import styled from "styled-components";

export const PoolItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--fd-space-space-4);
`;
